import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Comments from '@/pages/home/components/Comments';
import MediaSection from '@/pages/home/components/MediaSection';
import AppEntry from '@/pages/home/components/AppEntry';
import ContactEntry from '@/pages/home/components/ContactEntry';
import Topics from '@/pages/home/components/Topics';
import Features from '@/pages/home/components/Features';
import Carousel from '@/pages/home/components/Carousel';
import Updates from '@/pages/home/components/Updates';
import About from '@/pages/home/components/About';
import Index from '@/pages/home/components/Index';
import Faq from '@/pages/home/components/Faq';
import Ranking from '@/pages/home/components/Ranking';
import Cards from '@/pages/home/components/Cards';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Comments />
        <MediaSection />
        <AppEntry />
        <ContactEntry />
        <Topics />
        <Features />
        <Carousel />
        <Updates />
        <About />
        <Index />
        <Faq />
        <Ranking />
        <Cards />
      </main>
      <Footer />
    </div>
  );
}